import React, { FC } from 'react';
import { COPYRIGHT_TEXT } from '../../config/constants';

interface Props {
  text?: string;
  className?: string;
}

const DEFAULT_TEXT = COPYRIGHT_TEXT;

export const CopyrightFooter: FC<Props> = ({ text = DEFAULT_TEXT, className }) => {
  return (
    <div className={`copyright-section ${className || ''}`.trim()}>
      <div className="copyright-text">{text}</div>
    </div>
  );
};

export default CopyrightFooter;



